<template>
  <v-container>
    <v-row>
      <v-col>
        <v-icon
          class="hour-action"
          dark
          left
          v-if="$route.params.id > 1"
          @click="prevHour($route.params.id)">
          mdi-arrow-left
        </v-icon>
        <h1 id="hour-title">Hour {{ $route.params.id }}</h1>
        <v-icon class="hour-action" color="yellow" v-if="thisHour !== undefined && thisHour.speedRound">
          mdi-alarm-light
        </v-icon>
        <v-icon
          class="hour-action"
          dark
          left
          v-if="$route.params.id != latestHour"
          @click="nextHour($route.params.id)">
          mdi-arrow-right
        </v-icon>
      </v-col>
      <v-col class="new-hour" v-if="recorderMode">
        <template>
          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="ma-2" color="primary" v-on="on">
                  <v-icon>mdi-headphones</v-icon> Hours
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="newHour">
                  <v-list-item-title>Create New Hour</v-list-item-title>
                </v-list-item>
                <v-list-item @click="makeCurrentHour($route.params.id)">
                  <v-list-item-title>Make Current Hour</v-list-item-title>
                </v-list-item>
                <v-list-item @click="makeSpeedRound" color="warning">
                  <v-list-item-title>Speed Round</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-col>
    </v-row>
    <template  v-if="questions !== undefined">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">#</th>
            <th class="text-left">Question</th>
            <th class="text-left">Answer</th>
            <th class="text-left">Submitted By</th>
            <th class="text-left">Points</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="question in questions"
              :key="question.name"
              @click="goToQuestion(question)"
              :class="rowColor(question)">
            <td>{{ question.questionNumber }}</td>
            <td>{{ question.text }}
              <v-icon v-if="question.visual">mdi-image-area</v-icon>
              <v-icon v-if="question.isAudio">mdi-music</v-icon>
              <v-icon v-if="question.oneDone" :class="(!question.oneDoneSubmitted && question.open) ? 'one-done' : ''">
                      mdi-dice-1
              </v-icon>
            </td>
            <td>{{ (question.solution) ? question.solution.text : '' }}</td>
            <td>{{ (question.solution) ? question.solution.submittedBy : '' }}</td>
            <td>{{ question.pointValue }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    </template>
    <template v-else>
      <v-skeleton-loader
        type="table"
      />
    </template>
    <v-row v-if="recorderMode">
      <v-col cols="2">
        <v-select
          :items="availableQuestions"
          :value="newQuestion"
          outlined
          dense
          append-outer-icon="mdi-plus-circle"
          @click:append-outer="makeNewQuestion(thisHour.hourNumber, newQuestion)"
        ></v-select>
      </v-col>
    </v-row>
    <template>
      <v-row justify="center">
        <v-dialog v-model="newHourDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">New Hour</v-card-title>
            <v-col class="d-flex" cols="12">
              <v-select
                v-model="makeHour"
                :items="availableHours"
                label="Hour Number"
                dense
              ></v-select>
            </v-col>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="closeNewHourDialog()">Close</v-btn>
              <v-btn color="green darken-1" text @click="saveNewHour(makeHour)">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { range } from 'lodash'

export default {
  data () {
    return {
      availableQuestions: [],
      newQuestion: null,
      newHourDialog: false,
      makeHour: this.latestHour + 1,
      availableHours: [],
    }
  },
  beforeRouteEnter (to, from, next) {
    document.title = 'Hour ' + to.params.id + ' | Meyerbase'
    next()
  },
  beforeRouteUpdate (to, from, next) {
    document.title = 'Hour ' + to.params.id + ' | Meyerbase'
    next()
  },
  computed: {
    questions: function () {
      return this.$store.getters['questions/getQuestionsForHour'](this.$route.params.id)
    },
    latestHour: function () {
      return this.$store.getters['hours/getLatestHour']()
    },
    thisHour: function () {
      return this.$store.getters['hours/getHourDetail'](this.$route.params.id)
    },
    thisHourKey: function () {
      return this.$store.getters['hours/getHourKey'](this.$route.params.id)
    },
    recorderMode: function () {
      return this.$store.getters['currentHour/getRecorderMode']()
    },
    ...mapState({
      me: state => state.me,
    }),
  },
  mounted: async function () {
    await this.$store.dispatch('currentHour/bindCurrent')
    await this.$store.dispatch('hours/bindHours')
    await this.$store.dispatch('questions/bindHourQuestions', this.$route.params.id)
    this.setDefaults()
  },
  methods: {
    setDefaults: function () {
      if (this.thisHour && this.questions) {
        let openQuestions = []
        let stopBefore = 10
        if (this.thisHour.speedRound) {
          stopBefore = 19
        }
        openQuestions = range(1, stopBefore)
        for (const question in this.questions) {
          openQuestions.splice(openQuestions.indexOf(this.questions[question].questionNumber), 1)
        }
        this.availableQuestions = openQuestions
        this.newQuestion = openQuestions[0]
      }
    },
    goToQuestion: function (question) {
      this.$router.push(`/hour/${question.hourNumber}/question/${question.questionNumber}`)
    },
    nextHour: function (hourParam) {
      let hourNumber = parseInt(hourParam)
      this.$router.push(`/hour/${hourNumber + 1}`)
    },
    prevHour: function (hourParam) {
      let hourNumber = parseInt(hourParam)
      this.$router.push(`/hour/${hourNumber - 1}`)
    },
    newHour: function () {
      this.availableHours = range(this.latestHour + 1, 51)
      this.makeHour = this.latestHour + 1
      this.newHourDialog = true
    },
    saveNewHour: function (hourNumber) {
      let hour = {
        hourNumber: hourNumber,
        createdBy: this.me.username,
        speedRound: false,
        kvscPointTotal: 0,
        ptsFromPrev: 0,
        ptsToNext: 0,
        kvscRank: 0,
      }
      this.$store.dispatch('hours/addHour', hour)
      this.newHourDialog = false
    },
    closeNewHourDialog: function () {
      this.newHourDialog = false
    },
    makeCurrentHour: function (hour) {
      let theHour = parseInt(hour)
      this.$store.dispatch('currentHour/changeCurrentHour', { hourNumber: theHour })
    },
    makeNewQuestion: function (hourNumber, questionNumber) {
      let qNum = parseInt(questionNumber)
      let question = {
        questionNumber: qNum,
        hourNumber: parseInt(hourNumber),
        createdBy: this.me.username,
        open: true,
        correct: false,
        oneDone: false,
        oneDoneSubmitted: false,
        text: '',
        pointValue: 0,
        audioUrl: '',
        activeParticiPants: [],
        totalParticiPants: [],
        visual: '',
        solution: {
          questionNumber: qNum,
        },
      }
      this.$store.dispatch('questions/addQuestion', question)
      this.$router.push(`/hour/${hourNumber}/question/${questionNumber}/edit`)
    },
    makeSpeedRound: function () {
      this.$store.dispatch('hours/toggleSpeedRound', {
        hourKey: this.thisHourKey,
        speedRound: !this.thisHour.speedRound,
      })
    },
    toggleRecorderMode: function () {
      this.$store.commit('currentHour/toggleRecorderMode', !this.recorderMode)
    },
    rowColor: function (question) {
      if (!question.open) {
        if (question.correct) {
          return 'success'
        } else {
          return 'error'
        }
      } else if (question.oneDone && question.oneDoneSubmitted) {
        return 'deep-purple lighten-1'
      }
      return ''
    },
    getDayHour: function (hour) {
      let dayCounter = 1
      let hourCounter = hour
      if (hour > 6) {
        dayCounter = 2
        hourCounter = hour - 6
      }
      if (hour > 22) {
        dayCounter = 3
        hourCounter = hour - 22
      }
      return 'D' + dayCounter + ':H' + hourCounter
    },
  },
  watch: {
    thisHour: function (newO, oldO) {
      if (newO !== undefined) {
        this.$store.dispatch('questions/bindHourQuestions', newO.hourNumber)
      } else if (oldO !== undefined) {
        this.$store.dispatch('questions/bindHourQuestions', oldO.hourNumber)
      }
    },
    questions: 'setDefaults', // TODO: Can we use this to update the Dashboard in 2022?
  },
}
</script>

<style scoped>
  tr {
    cursor: pointer;
  }

  .one-done {
    color: #7E57C2;
  }

  #hour-title {
    display: inline-block;
  }

  .hour-action {
    padding: 10px;
  }

  .new-hour {
    text-align: right;
  }
</style>
